
import MessageBox from '@nextrequestco/components/src/components/MessageBox/MessageBox.vue'
import NrEditor from '@nextrequestco/components/src/components/NrEditor/nr-editor.vue'
import humanFriendlyDateTime from '../../../../mixins/humanFriendlyDateTime'
import { mapActions, mapState } from 'vuex'
import NrSelect from '@nextrequestco/components/src/components/NrSelect/nr-select.vue'
import NrDatepicker from '@nextrequestco/components/src/components/NrDatePicker/nr-datepicker.vue'
import NrIcon from '@nextrequestco/components/src/components/NrIcon/NrIcon.vue'
import NrFormLabel from '@nextrequestco/components/src/components/form-elements/nr-form-label.vue'

export default {
  name: 'TaskModal',
  components: {
    NrFormLabel,
    MessageBox,
    'nr-editor': NrEditor,
    NrSelect,
    NrDatepicker,
    NrIcon
  },
  mixins: [humanFriendlyDateTime],
  created() {
    if (this.$ability.can('read', 'staff_only_items')) {
      this.fetchInvoiceTemplates(this.request.id)
    }
  },
  watch: {
    displayCreateTaskMsgBox(val) {
      if (val.type === 'new') {
        this.taskMsg = ''
        this.taskDueDate = ''
        this.selectedCreateTaskAssignee = null
      }
      if (val.type === 'edit') {
        this.taskDueDate = this.humanFriendlyDate(
          new Date(this.editingTask.due_date)
        )
        this.taskMsg = this.editingTask.description
        this.selectedCreateTaskAssignee = {
          value: this.editingTask.user.id,
          label: this.editingTask.user.name_with_email,
          user_id: this.editingTask.user.id
        }
      }
    }
  },
  data() {
    return {
      selectedCreateTaskAssignee: {},
      taskMsg: '',
      taskDueDate: ''
    }
  },
  computed: {
    ...mapState('request_show', [
      'requestStaff',
      'currentAction',
      'displayCreateTaskMsgBox',
      'editingTask',
      'request'
    ]),

    disableTaskSubmitBtn() {
      return !(
        this.selectedCreateTaskAssignee &&
        Object.keys(this.selectedCreateTaskAssignee).length &&
        this.taskDueDate &&
        this.taskMsg.length
      )
    },

    requestStaffList() {
      return this.requestStaff
        .map((item) => {
          return {
            id: item.id,
            label: item.name_with_email
          }
        })
        .concat([
          { id: this.request.poc.id, label: this.request.poc.name_with_email }
        ])
    }
  },

  methods: {
    ...mapActions('request_show', [
      'submitNewTask',
      'fetchInvoiceTemplates',
      'setDisplayCreateTaskMsgBox'
    ]),

    handleCancelMessage() {
      this.taskMsg = ''
      this.taskDueDate = null
      this.selectedCreateTaskAssignee = {}
      this.setDisplayCreateTaskMsgBox({ display: false, type: 'new' })
    },

    handleCloseTask() {
      this.setDisplayCreateTaskMsgBox({ display: false })
    },

    handleSubmitTask() {
      this.submitNewTask({
        action_type: this.displayCreateTaskMsgBox.type,
        description: this.taskMsg,
        due_date: this.humanFriendlyDate(this.taskDueDate),
        request_id: this.request.pretty_id,
        task_id: this.editingTask.id,
        user_id:
          this.selectedCreateTaskAssignee.user_id ||
          this.selectedCreateTaskAssignee.id
      })
    }
  }
}
